module.exports = __webpack_public_path__ + "img/Reddit Icon.dcc965bd.svg";